import { NavLink } from "react-router-dom";
import { MenuOutline } from "react-ionicons";
import { CloseOutline } from "react-ionicons";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import LangSelector from "./LangSelector";
import {
  ENTERPRISE_PORTAL_SIGNUP_URL,
  ENTERPRISE_PORTAL_URL,
} from "../constants";
import { useTranslation } from "react-i18next";

interface HeaderProps {
  image: string;
  siteName: string;
  menu: MenuItem[];
  onBtnClick: () => void;
  onSelectLang: (lang: string) => void;
  btnName: string;
  currentLang: string;
  login: string;
  registration: string;
  essai: string;
}

interface MenuItem {
  name: String;
  to: string;
}

function Header({
  siteName,
  image,
  menu,
  essai,
  login,
  registration,
  onSelectLang,
  currentLang,
}: HeaderProps) {
  const [isOpen, setOpen] = useState(false);
  const onClickMenuClose = () => setOpen(!isOpen);
  const { t } = useTranslation("global");
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("mousedown", onOutSideClick);

    return () => {
      document.addEventListener("mousedown", onOutSideClick);
    };
  }, []);

  const onOutSideClick = (event: MouseEvent) => {
    if (
      headerRef.current &&
      !headerRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };
  
  const location = useLocation();
  
  return (
    <header
      className="flex items-center justify-between md:mx-5 lg:px-7 bg-white shadow-sm"
      ref={headerRef}
    >
      <NavLink to={"/"}>
        <div className="flex p-6 space-x-2 items-center">
          <div className="shrink-0">
            <img src={image} className="w-12" alt="logo" />
          </div>
          <div className="text-xl font-heading font-semibold text-black">{siteName}</div>
        </div>
      </NavLink>

      <div
        className={`flex flex-col md:flex-row
           absolute md:static
          pl-3 md:pl-0
          pb-7 md:pb-0
          space-y-3 md:space-y-0
          items-start md:items-center
          z-[1] md:z-0
          w-full md:w-auto
          bg-white 
          shadow-lg md:shadow-none
          md:space-x-7
          transition-all
          duration-300 
          ${isOpen ? "top-20" : "-top-96"}`}
      >
        {menu.map((item, index) => {
          return (
            <div className="group" key={index}>
              <NavLink
                to={item.to}
                className={({ isActive }) => {
                  return isActive
                    ? `text-blue-600 font-heading font-medium inline-block`
                    : `text-black font-heading font-medium inline-block hover:text-blue-600`;
                }}
                onClick={() => {
                  if (isOpen) {
                    setOpen(!isOpen);
                  }
                }}
              >
                {item.name}
                <div
                  className={`h-0.5 w-0 group-hover:w-full m-auto transition-all duration-300 rounded-lg bg-blue-600`}
                ></div>
              </NavLink>
            </div>
          );
        })}
      
        <div className="group">
          <a
            href={ENTERPRISE_PORTAL_URL}
            className="text-black font-heading font-medium inline-block hover:text-blue-600 cursor-pointer"
          >
            {login}
            <div
              className={`h-0.5 w-0 group-hover:w-full m-auto transition-all duration-300 rounded-lg bg-blue-600`}
            ></div>
          </a>
        </div>
        
        <div className="md:hidden">
          <LangSelector
            onSelectLang={onSelectLang}
            selectedLang={currentLang}
          />
        </div>
      </div>

      <div className="flex md:hidden mr-2 cursor-pointer">
        {isOpen ? (
          <CloseOutline
            color={"#2563EA"}
            title={"close"}
            height="30px"
            width="30px"
            onClick={onClickMenuClose}
          />
        ) : (
          <MenuOutline
            color={"#2563EA"}
            title={"menu"}
            height="30px"
            width="30px"
            onClick={onClickMenuClose}
          />
        )}
      </div>

      <div className="hidden md:flex md:items-center">
        <a
          className="bg-blue-600 hover:bg-blue-700 transition-colors h-10 flex items-center font-heading font-medium px-6 rounded-full text-white"
          href={ENTERPRISE_PORTAL_SIGNUP_URL}
        >
          {essai}
        </a>

        <LangSelector onSelectLang={onSelectLang} selectedLang={currentLang} />
      </div>
    </header>
  );
}

export default Header;